import React, { FC, useEffect } from "react";
import { FoundryProviderProps } from "./foundryProviderInterfaces";
import { useFoundryProvider } from "./store";
import { MetaMaskProvider } from "@metamask/sdk-react";
import { WagmiProvider } from "wagmi";
import { config } from "../wallet-connector/web3React/connectors";
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// const queryClient = new QueryClient({});

export const FoundryProvider: FC<FoundryProviderProps> = ({
  children,
  supportedConnectors,
  AlgoSignerLedger,
}: FoundryProviderProps) => {
  const { setConnectors, setAlgoSignerLedger } = useFoundryProvider();

  useEffect(() => {
    if (supportedConnectors && supportedConnectors.length > 0) {
      setConnectors(supportedConnectors);
    }
  }, [supportedConnectors]);

  useEffect(() => {
    if (AlgoSignerLedger) {
      setAlgoSignerLedger(AlgoSignerLedger);
    }
  }, [AlgoSignerLedger]);

  return (
    <>
      <WagmiProvider config={config}>
        <MetaMaskProvider
          debug={false}
          sdkOptions={{
            dappMetadata: {
              name: "MultiSwap Dapp",
              url: window.location.host,
            },
          }}
        >
          {/* <QueryClientProvider client={queryClient}> */}
          {children}
          {/* </QueryClientProvider> */}
        </MetaMaskProvider>
      </WagmiProvider>
    </>
  );
};
